import * as React from "react";
import { Drawer, Modal, Icon, Input } from "antd";
import CommenScanner from "./commenScanner";
import { Document, Page, pdfjs } from "react-pdf";
import { logger } from "../../constant/winston";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

type ScannerDrawerProps = {
  ipc: any;
};

type ScannerDrawerState = {
  scannerData: any;
  imageData: string;
  imageViewer: any;
  drawerVisibility?: boolean;
  pdfViewer: boolean;
  PdfData: any;
};

export class ScannerDrawer extends React.Component<
  ScannerDrawerProps,
  ScannerDrawerState
> {
  state = {
    drawerVisibility: false,
    enableScanner: false,
    scannerData: "",
    imageViewer: false,
    imageData: "",
    pdfViewer: false,
    PdfData: "",
  };

  componentDidMount() {
    window.addEventListener("message", this.ipcListener);
  }
  ipcListener = async (e: any) => {
    let { data } = e;
    try {
      // if (
      //   origin === "http://localhost:3001" ||
      //   origin === "https://storage.googleapis.com"
      // ) {
      if (data.action && data.action === "openScannerDrawer") {
        this.setState(
          {
            scannerData: data.values.scannerData,
          },
          () => {
            this.handleDrawerVisibility(true);
          }
        );
      } else if (data.action && data.action === "closeScannerDrawer") {
        this.handleDrawerVisibility(false);
      } else if (data.action && data.action === "openImageView") {
        if (data.values.fileType && data.values.fileType.includes("pdf")) {
          let source = null;
          if (typeof data.values.file === "string") {
            if (data.values.file.includes("base64")) {
              source = { result: data.values.file };
            } else {
              source = { result: { url: data.values.file } };
            }
          } else {
            source = data.values.file;
          }
          this.setState({
            PdfData: source,
            pdfViewer: true,
          });
        } else {
          this.setState({
            imageData: data.values.imageData,
            imageViewer: true,
          });
        }
        let bodyPointer: any = document.querySelector("body");
        bodyPointer.style.paddingRight = "0px";
      }
      // else if (data.action && data.action === "openPdfViewer") {
      //
      // let bodyPointer: any = document.querySelector("body");
      // bodyPointer.style.paddingRight = "0px";
      // }
    } catch (error) {
      logger.error(error)
      throw error;
    }
  };

  componentWillUnmount() {
    //remove postMessage listener
    window.removeEventListener("message", this.ipcListener);
  }

  handleDrawerVisibility = (action: boolean) => {
    this.setState({
      drawerVisibility: action,
    });
  };

  handleImageViewer = (action: boolean) => {
    this.setState({
      imageViewer: action,
    });
  };
  handlePdfViewer = (action: boolean) => {
    this.setState({
      pdfViewer: action,
    });
  };

  render() {
    return (
      <React.Fragment>
        <Drawer
          data-test-id="scanner_drawer"
          placement="right"
          closable={false}
          className="scannerDrawer"
          width={"400px"}
          destroyOnClose={true}
          onClose={() => {
            this.handleDrawerVisibility(false);
            // let bodyPointer = document.querySelector("body");
            //   // overflow: hidden; touch-action: none; position: relative; width: calc(100% - 15px);
            //   bodyPointer.style.overflow="hidden";
            //   bodyPointer.style.touchAction="none";
            //   bodyPointer.style.position="relative";
            //   bodyPointer.style.width="calc(100% - 15px)";
          }}
          visible={this.state.drawerVisibility}
          afterVisibleChange={(v) => {
            // let bodyPointer = document.querySelector("body");
            if (v === false) {
              // overflow: hidden; touch-action: none; position: relative; width: calc(100% - 15px);
              // bodyPointer.style.overflow="hidden";
              // bodyPointer.style.touchAction="none";
              // bodyPointer.style.position="relative";
              // bodyPointer.style.width="calc(100% - 15px)";
            }
          }}
        >
          <div className="scannerHelperWrapper">
            <div className="scannerHelperHeader">
              <h2 className="card-item-details-head-title scannerDrawerHeader">
                <i
                  data-test-id="scan_your_document"
                  onClick={this.handleDrawerVisibility.bind(this, false)}
                  className="icon-left-arrow scannerDrawerHeaderIcon"
                />
                Scan Your Document
              </h2>
              <hr style={{ margin: "0px", marginBottom: "16px" }} />
            </div>
            <CommenScanner
              data-test-id="commen_scanner"
              handleDrawer={this.handleDrawerVisibility}
              scannerData={this.state.scannerData}
              ipc={this.props.ipc}
            />
          </div>
        </Drawer>
        <Modal
          data-test-id="image_viewer"
          title="Image Viewer"
          centered
          maskClosable={false}
          className="scannerModalWrapper"
          visible={this.state.imageViewer}
          footer={null}
          zIndex={1003}
          onCancel={this.handleImageViewer.bind(this, false)}
          afterClose={() => {
            let bodyPointer: any = document.querySelector("body");
            bodyPointer.style.overflow = "hidden";
          }}
        >
          <img
            src={this.state.imageData}
            alt="imageNotFound"
            className="responsiveScannerDocPreview"
          />
        </Modal>
        <Modal
          title="Pdf Viewer"
          centered
          className="scannerModalWrapper"
          visible={this.state.pdfViewer}
          maskClosable={false}
          footer={null}
          zIndex={1003}
          width={"auto"}
          style={{ width: "auto" }}
          onCancel={this.handlePdfViewer.bind(this, false)}
          afterClose={() => {
            let bodyPointer: any = document.querySelector("body");
            bodyPointer.style.overflow = "hidden";
          }}
        >
          <PdfViewerC data={this.state.PdfData} />
        </Modal>
      </React.Fragment>
    );
  }
}

interface PropsC {
  data: any;
}

interface StateC {
  result: any;
  pageNumber: string | number;
  numPages: string | number;
  zoom: number;
  rotate: number;
}

class PdfViewerC extends React.Component<PropsC, StateC> {
  state = {
    result: this.props.data,
    pageNumber: 1,
    numPages: "",
    zoom: 709,
    rotate: 0,
  };
  componentDidMount() { }
  onDocumentLoadSuccess = ({ numPages }: any) => {
    this.state.numPages !== numPages && this.setState({ numPages: numPages });
  };

  handlePage = (key: any) => {
    key !== 0
      ? key >= 1 &&
      key <= this.state.numPages &&
      this.setState({ pageNumber: key })
      : this.setState({ pageNumber: key });
  };
  handlPdferror = (error: any) => {
    logger.error("error in pdf viwer", error.message);
  };
  handleDownload = (data: any) => {
    let element = document.createElement("a");
    element.setAttribute("href", data.result);
    element.setAttribute("download", data.File.name);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };
  handleRotate = (key: number) => () => {
    this.setState({ rotate: key });
  };
  handlePaginationInput = (e: any) => {
    const { numPages } = this.state;
    const { value } = e.target;
    let numValue = Number(value);
    if (numValue < 1) {
      numValue = 1;
    }
    if (numValue > Number(numPages)) {
      numValue = Number(numPages);
    }
    this.handlePage(numValue);
  };
  render() {
    let { pageNumber, zoom, numPages, rotate } = this.state;
    let { data } = this.props;

    return (
      <div className="App12">
        {data && (
          <div style={{ background: "gray", padding: "12px" }}>
            <Document
              data-test-id="pdf_document_classname"
              file={
                // typeof this.props.data.result === "object"
                //   ? { data: this.props.data.result }
                // :
                this.props.data.result
              }
              className="pdf_document_ClassName"
              onLoadSuccess={this.onDocumentLoadSuccess}
              onLoadError={this.handlPdferror}
              rotate={rotate}
            // renderMode={"svg"}
            >
              <Page
                className="pdf_page_ClassName"
                pageNumber={pageNumber === 0 ? 1 : pageNumber}
                width={zoom}
              />
            </Document>
            <div>
              <p
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <p
                  style={{
                    display: "flex",
                    width: "136px",
                    justifyContent: "space-between",
                    marginTop: "7px",
                    marginBottom: "0px",
                    padding: "5px",
                    borderRadius: "8px",
                    background: "white",
                    color: "black",
                  }}
                >
                  <span data-test-id="page_left" onClick={() => this.handlePage(pageNumber - 1)}>
                    <Icon type="left" style={{ color: "black" }} />
                  </span>
                  <Input
                    data-test-id="number"
                    style={{ width: "50px", marginTop: "-2px", height: "24px" }}
                    value={pageNumber === 0 ? 1 : pageNumber}
                    type="number"
                    onChange={this.handlePaginationInput}
                  />
                  / <span>{numPages}</span>
                  <span data-test-id="page_right" onClick={() => this.handlePage(pageNumber + 1)}>
                    <Icon type="right" />
                  </span>
                </p>
              </p>
              <p
                style={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "0px",
                  marginBottom: "0px",
                }}
              >
                <p
                  style={{
                    padding: "5px",
                    borderRadius: "8px",
                    background: "white",
                  }}
                >
                  <span
                    data-test-id="download"
                    style={{ marginRight: "15px", cursor: "pointer" }}
                    onClick={this.handleDownload.bind(this, data)}
                  >
                    <Icon style={{ color: "black" }} type="download" />
                  </span>
                  <span style={{ marginRight: "15px", cursor: "pointer" }}>
                    <Icon
                      data-test-id="zoom_in"
                      type="zoom-in"
                      onClick={() => {
                        this.setState({ zoom: this.state.zoom + 100 });
                      }}
                      style={{ marginRight: "15px", color: "black" }}
                    />
                    <Icon
                      type="zoom-out"
                      data-test-id="zoom_out"
                      style={{ color: "black" }}
                      onClick={() => {
                        this.setState({ zoom: this.state.zoom - 100 });
                      }}
                    />
                  </span>
                  <span style={{ marginRight: "15px", cursor: "pointer" }}>
                    <Icon
                      type="undo"
                      data-test-id="undo"
                      style={{ color: "black" }}
                      onClick={this.handleRotate(rotate - 90)}
                    />
                  </span>
                  <span style={{ marginRight: "15px", cursor: "pointer" }}>
                    <Icon
                      type="redo"
                      data-test-id="redo"
                      style={{ color: "black" }}
                      onClick={this.handleRotate(rotate + 90)}
                    />
                  </span>
                </p>
              </p>
            </div>
          </div>
        )}
      </div>
    );
  }
}
